// One entry per dashboard. A user can open it if their allowed_users.apps
// contains any of `flags`. 'systemadmin' is a superset flag (also enforced server-side
// by is_allowed_for_app); 'finance' gates pages that show financials.
export const DASHBOARDS = [
  {
    id: 'main',
    path: '/dashboard',
    title: 'Team Analytics',
    description: 'Team members, departments, client P&L, cost & utilization, PTO and overrides.',
    flags: ['finance'],
  },
  {
    id: 'teamhours',
    path: '/team-hours',
    title: 'Team Hours',
    description: 'Logged hours vs capacity by client, department, day and person, with billable utilization.',
    flags: ['finance'],
  },
  {
    id: 'directreports',
    path: '/direct-reports',
    title: 'Direct Reports',
    description: 'Weekly hours by project, trends and private notes for the people who report to you.',
    flags: ['coreoperations'],
  },
  {
    id: 'ratecard',
    path: '/rate-card',
    title: 'Rate Card vs COR',
    description: 'Planned monthly hours per client and person versus actual hours logged in COR.',
    flags: ['ratecard'],
  },
  {
    id: 'users',
    path: '/users',
    title: 'User Management',
    description: 'Review who has access, their flags and last sign-in; grant or revoke access.',
    flags: [],
  },
];

// Flags an admin can grant from User Management, in display order.
export const APP_FLAGS = [
  { flag: 'systemadmin',    label: 'System admin',  description: 'Full access to every page, including User Management.' },
  { flag: 'finance',        label: 'Finance',       description: 'Team Analytics and other pages with financials.' },
  { flag: 'coreoperations', label: 'Direct Reports', description: 'Direct Reports (scoped to your own team).' },
  { flag: 'ratecard',       label: 'Rate Card',     description: 'Rate Card vs COR.' },
  { flag: 'teamhours',      label: 'Team Hours',    description: 'Read access to the team hours data (people, daily_hours, daily_pto). Finance already has this access.' },
];

export const canOpen = (apps, dashboard) =>
  apps.includes('systemadmin') || dashboard.flags.some(f => apps.includes(f));
